<div class="data_info {{type}}" 
  container="body" 
  [ngbTooltip]="tooltipText" 
  [placement]="tooltipPlacement" 
  container="body">
  
  <div class="quantity">{{quantity | formatPercent}}</div>
  <div class="title">{{ 'followup.summary.nps.'+type | translate }}</div>
</div>